import { ReactSession } from 'react-client-session';

const addToStore = (key, value) => {
	// console.log(`Adding ${key} to store: ${value}`, value);
	ReactSession.set(key, value);
};

export { addToStore };
